import { api } from ".."

// funcao para pesquisar centros de custo
const CostCentersService = async (description: string, page: number) => {

    const response = await api.get('cost_centers', {
        params: {
            description, page
        }
    });

    return response;

}
// funcao para pesquisar centros de custo

// funcao para cadastrar centros de custo
const CreateCostCenters = async (description: string, branch: string, code: string) => {

    const response = await api.post('cost_centers', {
        description, branch, code
    });

    return response;

}
// funcao para cadastrar centros de custo

// função para pesquisar dados do centro de custo
const CostCenterShowService = async (id: number) => {

    const response = await api.get(`cost_centers/${id}`);

    return response;

}
// função para pesquisar dados do centro de custo

// função para adicionar funcionário ao centro de custo
const CostCenterAddEmployeeService = async (cost_center: number, user: number) => {

    const response = await api.get(`cost_centers/${cost_center}/${user}`);

    return response;

}
// função para adicionar funcionário ao centro de custo

// função para desativar/ativar centro de custo
const CostCenterDeleteService = async (id: number) => {

    const response = await api.delete(`cost_centers/${id}`);

    return response;

}
// função para desativar/ativar centro de custo

export {
    CostCentersService,
    CreateCostCenters,
    CostCenterShowService,
    CostCenterAddEmployeeService,
    CostCenterDeleteService
}